import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getCompanyName, signOut } from '../auth';
import HowItWorksModal from './HowItWorksModal';

const Sidebar = () => {
  const navigate = useNavigate();
  const companyName = getCompanyName() || 'Management Portal';
  const [helpOpen, setHelpOpen] = useState(false);

  const handleLogout = () => {
    signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="w-64 h-screen bg-blue-800 text-white p-4">
      <h1 className="text-xl font-bold mb-8">{companyName}</h1>
      <nav>
        <ul className="space-y-2">
          <li>
            <Link to="/" className="block p-2 hover:bg-blue-700 rounded">
              Invoices Management
            </Link>
          </li>
          <li>
            <Link to="/past-due" className="block p-2 hover:bg-blue-700 rounded">
              Past Due Invoices
            </Link>
          </li>
          <li>
            <Link to="/quotes" className="block p-2 hover:bg-blue-700 rounded">
              Quotes Management
            </Link>
          </li>
          <li>
            <Link to="/quotes-update" className="block p-2 hover:bg-blue-700 rounded">
              Quotes Update
            </Link>
          </li>
          <li>
            <Link to="/upcoming-tests" className="block p-2 hover:bg-blue-700 rounded">
              Upcoming Tests
            </Link>
          </li>
          <li>
            <Link to="/upcoming-tests-update" className="block p-2 hover:bg-blue-700 rounded">
              Upcoming Tests Update
            </Link>
          </li>
        </ul>
      </nav>
      <Link
        to="/business-impact"
        className="mt-8 block rounded-lg border border-emerald-400/40 bg-emerald-500/15 px-3 py-2.5 hover:bg-emerald-500/25 transition-colors"
      >
        <div className="flex items-center gap-2">
          <svg className="h-4 w-4 text-emerald-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
          </svg>
          <span className="text-sm font-semibold">Business Impact</span>
        </div>
        <p className="mt-0.5 text-[11px] text-emerald-200/80">View 90-day results</p>
      </Link>

      <button
        type="button"
        onClick={() => setHelpOpen(true)}
        className="mt-3 w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-left text-sm hover:bg-white/10 transition-colors flex items-center gap-2"
      >
        <svg className="h-4 w-4 text-blue-200 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <span className="font-medium">How it works</span>
      </button>

      <button
        type="button"
        onClick={handleLogout}
        className="mt-3 w-full rounded bg-blue-950 px-4 py-2 text-left hover:bg-blue-900"
      >
        Log Out
      </button>

      <HowItWorksModal open={helpOpen} onClose={() => setHelpOpen(false)} />
    </div>
  );
};

export default Sidebar;
